export default {
  setUsuario(state, usuario) {
    state.usuario = usuario;
  },
  setFases(state, sad) {
    state.fases = sad;
  },
  setSedes(state, sedes) {
    state.sedes.push(...sedes);
  },
  setNominaExaminador(state, sad) {
    state.nominaExaminador = sad;
  },
  setFunciones(state, sad) {
    state.funciones = sad;
  },
  setBancos(state, bancos) {
    state.bancos = bancos;
  },
  setEstadoConfirmar(state, update) {
    state.estadoConfirmar = update;
  },
  setModulos(state, sad) {
    state.modulos = sad;
  },
  setRoles(state, roles) {
    state.roles = roles;
  },
  setPaises(state, update) {
    state.paises = update;
  },
  setProceso(state, update) {
    state.proceso = update;
  },
};
